module.exports = __webpack_public_path__ + "media/images/lb/786-fc97ac70f69eaa9f4708b614b17c3a4d.svg";